<script lang="ts">
  import PoemsList from './PoemsList.svelte'
  import {t} from '../i18n'
</script>

<PoemsList title={t.favorite.title} url="/poems/favorite" emptyPlaceholder={t.favorite.no_poems}/>
